import React, {useState, useEffect, useContext, Fragment} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import 'react-times/css/classic/default.css';
import {Link} from 'react-router-dom';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from "../../../../assets/images/imageData";
import {Button} from "react-bootstrap";
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {toast} from "react-toastify";
import useLatLng from 'hooks/uselatlng/uselatlng';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { calcCrow } from 'services/utils/helpers/customHelper';
import {
  checkoutErrorMessage,
  isCheckoutApiSuccess,
  resolveDistanceRowId,
} from 'services/attendance/siteCheckout';

const SiteVisitList = ({
                        getSiteVisitList,
                        siteData,
                        distanceDetails,
                        history,
                        getDistanceData,
                        engDistanceData,
                        getSiteData,
                        rmCheckOutRequest,
                        rmCheckOutResponse,
                        siteVisitList
                          }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [pageCount, setPageCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [role, setRole] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [siteId, setSiteId] = useState('');
    const [checkSiteIdSet, siteIdSetChecked] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);
    const islatlng = useLatLng();

    useEffect(() => {
        (async () => {
            let roles = JSON.parse(localStorage.getItem('roles'))
            setRole(roles[0]?.id)
            setIsLoading(true)
            await getSiteVisitList()
            setIsLoading(false)
        })()
    }, [])


    const headers = [
        'Engineer Name',
        'Client Name',
        'Latitude',
        'Longitude',
        'Task Date',
        'Task Type',
        'Requested By',
        'Distance',
        'Action'
    ];

    useEffect(() => {
        let action = {}
        if (siteVisitList && siteVisitList?.data && siteVisitList?.data !== []) {
            let tableHeaders = ['id', 'name', 'client_name', 'lat', 'long', 'task_date', 'task_type', 'requested_by' , 'distance_in_km'];
            const data = siteVisitList?.data.map((element) =>
                Object.assign(
                    {},
                    ...tableHeaders.map((key) => (
                        {[key]: element[key]}
                    )),
                    {
                        Actions: {
                            name: 'View Details',
                            link: `${baseUrl}/site-visit-view/${element['id']}`,
                        },
                    }
                )
            )
            data && setListData(data);
        }

        setPageCount(Math.ceil(siteVisitList.total / siteVisitList.per_page));

    }, [siteVisitList])


        useEffect(() => {
            let roles = JSON.parse(localStorage.getItem('roles'))
            setRole(roles[0]?.id)
            setSiteId(siteVisitList?.data?.[0]?.site_id)
            delete siteVisitList?.data?.[0]?.site_id
            setIsOpen(!isOpen);
        }, [])
        useEffect(() => {
            if(siteId) {
            (async () => {
                await getSiteData(siteId)
            })();
            }
        }, [siteId]);

        useEffect( () => {
            (async () => {
              if(siteVisitList !== null && siteVisitList?.data != null && Object.keys(siteVisitList?.data).length > 0){
                setIsLoading(true)
                if(siteVisitList?.data?.[0]?.site_id !== undefined){
                  await getDistanceData(siteVisitList?.data?.[0]?.site_id, 'Task')
                }
                setSiteId(siteVisitList?.data?.[0]?.site_id)
                siteIdSetChecked(true)
                setIsLoading(false)
              }
            })()
          }, [siteVisitList])


    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await getSiteVisitList(filter, val.selected + 1)
        setIsLoading(false);
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const applyFilter = async (filterData) => {
        localStorage.setItem("site_visit", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await getSiteVisitList(filterData, 1);
        setIsLoading(false);
        filterToggle();
    };


    useEffect( () => {
        if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
          if(engDistanceData?.alreadyCheckIn == true) {
            toast.warning(engDistanceData?.message);
            history.push(`${baseUrl}/site-visit-list`);
            setTimeout(() => { 
              window.location.reload();
            },1000);
          } else {
            toast.success('Distance is successfully fetched');
            window.location.reload();
            setIsOpen(false);
            Object.keys(engDistanceData).forEach(key => {
              delete engDistanceData[key];
            })
          }
        }else if(engDistanceData === null){
          toast.success('Distance is not fetched');
          setIsOpen(true);
        }
      }, [engDistanceData])



    const handleCheckOut = async (passedId) => {
        const id = passedId || resolveDistanceRowId(distanceDetails);
        if (!id) {
            toast.error('Check-in record not found.');
            return false;
        }
        const checkout_lat = Number(islatlng?.lat);
        const checkout_long = Number(islatlng?.lng);
        if(isNaN(checkout_lat) || isNaN(checkout_long)) {
          alert(localization.locationPermission);
          return false;
        }

        // "Other" check-in uses site_id 0 and has no lead — use check-in coords only for that case
        const checkedInSiteId = distanceDetails?.site_id ?? siteId;
        const isOtherSite = checkedInSiteId === 0 || checkedInSiteId === '0';
        const siteLat = isOtherSite
          ? Number(distanceDetails?.site_lat ?? distanceDetails?.lat)
          : siteData['lead']['latitude'];
        const siteLong = isOtherSite
          ? Number(distanceDetails?.site_long ?? distanceDetails?.long)
          : siteData['lead']['longitude'];

        if (isOtherSite && (isNaN(siteLat) || isNaN(siteLong))) {
          toast.error('Site location not available. Please try again.');
          return false;
        }

        var checkout_distance = calcCrow(checkout_lat, checkout_long, siteLat, siteLong);
        if(isNaN(checkout_distance) || checkout_distance == null || checkout_distance == undefined) {
          toast.error('Distance Not Fetched.');
          return false;
        }

        const payload = {
          'id':id,
          'checkout_lat':checkout_lat,
          'checkout_long':checkout_long,
          'checkout_distance_in_km': checkout_distance,
          'checkout_remark':'',
        }

        setIsLoading(true);
        try {
          const res = await rmCheckOutRequest(payload);
          if (isCheckoutApiSuccess(res?.data) || res?.success) {
            toast.success('Checkout Successfully.');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            return true;
          }
          toast.error(checkoutErrorMessage(res?.data));
        } catch (err) {
          toast.error(checkoutErrorMessage(err?.response?.data));
        } finally {
          setIsLoading(false);
        }
        return false;
      }

    const headerBtns = () => {
        return (
            <>
            {window.screen.width < 600?
                <div className="Pm-btn pm-btn-align">

                {distanceDetails && distanceDetails.lat != null && distanceDetails.checkout_lat == null ? (
                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                    <div className="btn-group" role="group">
                        <Button
                        className="btn btn-transparent btn-danger"
                        onClick={() => handleCheckOut(distanceDetails?.id)}
                        >
                        {localization.checkOut}
                        </Button>
                    </div>
                    </div>
                ) : ''}

                <a
                    href={`${baseUrl}/site-visit`}
                    className="filter-hamburger btn btn-default borderColorBox  filterButton"
                    >
                   Visit
                 </a>
                 <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""></img>
                    {/* {localization.showFilters} */}
                </Button>
               
            </div>
            :
            <>

            {distanceDetails && distanceDetails.lat != null && distanceDetails.checkout_lat == null ? (
                <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                <div className="btn-group" role="group">
                    <Button
                    className="btn btn-transparent btn-danger"
                    onClick={() => handleCheckOut(distanceDetails?.id)}
                    >
                    {localization.checkOut}
                    </Button>
                </div>
                </div>
            ) : ''}

                <div className="Pm-btn pm-btn-align">
                    <Link
                        to={`${baseUrl}/site-visit`}
                        className="btn btn-primary d-none d-md-inline-block"
                    >
                        {localization.siteVisitTask}
                        <img src={Images?.ArrowRight} alt=""></img>
                    </Link>
                </div>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""></img>
                    {localization.showFilters}
                </Button>
            </>
            }
            </>
        )
    }
    return (
        <Layout
            title={localization.w}
            Buttons={headerBtns}
            isLoading={isLoading}
            isGoback={true}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                srNo={siteVisitList?.from}
                onPageChange={onPageChange}
                pageCount={pageCount}
                detailList={siteVisitList}
            />
            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                networkEngFilter={true}
                isRoleId={role}
            />
        </Layout>
    );

};
export default SiteVisitList;